import React, { useEffect, useState } from 'react'
import { getWpFootballPosts } from '../../../api/api_wp'
import Loader from '../../Loader/Loader'
import PostsWpListTemplate from './templates/PostsWpListTemplate'

function PostsWP() {

    const [posts, setPosts] = useState([])
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(9)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {

        async function getPostsWp() {
            setIsLoading(true)
            const fetchedPosts = await getWpFootballPosts(page, perPage)
            const newPosts = posts.concat(fetchedPosts)
            setPosts(newPosts)
            setIsLoading(false)
        }
        getPostsWp()

    }, [page, perPage])

    return (
        <React.Fragment>
            
            <div className="row">
                {posts?.map((post, index) => {
                    return <PostsWpListTemplate key={index} post={post} />
                })}

            </div>
            {isLoading && <Loader />}
            {!isLoading && page * perPage <= posts?.length && (
                <div>
                    <button className="btn btn-success btn-block" onClick={() => setPage(page + 1)}>Last mer</button>
                </div>
            )}
        </React.Fragment>

    )
}
export default PostsWP